// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Model for Program Case Type
*/
export class ProgramCaseTypeModel {
    'programCaseTypeId'?: number;
    'caseTypeId'?: number;
    'caseTypeCode'?: string | null;
    'caseTypeDescription'?: string | null;
    'caseTypeCategoryId'?: number;
    'caseTypeCategoryCode'?: string | null;
    'caseTypeCategoryDescription'?: string | null;
    'createdFromIntake'?: boolean;
    'isWorkflowCase'?: boolean;
    'isWorkflow'?: boolean;
    'expirationPeriod'?: number | null;
    'isHidden'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ProgramCaseTypeModel>> = [
        {
            "name":     "programCaseTypeId",
            "baseName": "programCaseTypeId",
            "type":     "number"
        },
        {
            "name":     "caseTypeId",
            "baseName": "caseTypeId",
            "type":     "number"
        },
        {
            "name":     "caseTypeCode",
            "baseName": "caseTypeCode",
            "type":     "string"
        },
        {
            "name":     "caseTypeDescription",
            "baseName": "caseTypeDescription",
            "type":     "string"
        },
        {
            "name":     "caseTypeCategoryId",
            "baseName": "caseTypeCategoryId",
            "type":     "number"
        },
        {
            "name":     "caseTypeCategoryCode",
            "baseName": "caseTypeCategoryCode",
            "type":     "string"
        },
        {
            "name":     "caseTypeCategoryDescription",
            "baseName": "caseTypeCategoryDescription",
            "type":     "string"
        },
        {
            "name":     "createdFromIntake",
            "baseName": "createdFromIntake",
            "type":     "boolean"
        },
        {
            "name":     "isWorkflowCase",
            "baseName": "isWorkflowCase",
            "type":     "boolean"
        },
        {
            "name":     "isWorkflow",
            "baseName": "isWorkflow",
            "type":     "boolean"
        },
        {
            "name":     "expirationPeriod",
            "baseName": "expirationPeriod",
            "type":     "number"
        },
        {
            "name":     "isHidden",
            "baseName": "isHidden",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return ProgramCaseTypeModel.attributeTypeMap;
    }
}
